
import { StyleSizeType } from '@/ui-kit/styles/enums';
import ContainerOverviewNavigation from './navigation';
import ContainerOverviewHero from './hero';
import { ContainerOverviewSlotName } from './enums';

export default {
  name: 'ContainerOverview',
  components: {
    ContainerOverviewHero,
    ContainerOverviewNavigation,
  },
  props: {
    heroImage: {
      default: () => ({}),
      type: Object,
    },
    heroTitle: {
      default: '',
      type: String,
    },
    isSticky: {
      default: true,
      type: Boolean,
    },
    heroDescription: {
      default: '',
      type: String,
    },
    heroCarouselItems: {
      default: () => ([]),
      type: Array,
    },
    heroCarouselTrackEvent: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      ContainerOverviewSlotName,
      StyleSizeType,
    };
  },
};
